import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DaysView } from 'components/availability/form/list_view/days_view';
/* Fixed day column: each Day row is its own grid, so auto-sized day
   labels ("Mon" vs "Wed") shift the time boxes. */

const customHoursViewIsTabletUpCss = "cmdhj99";
const customHoursViewIsRedesignStylingCss = "c1vdnbdd";
const customHoursViewCompactCss = "c4md82k";
const customHoursViewIsExtraSmallPhoneCss = "c1t23szr";
const customHoursViewIsV4StylingCss = "c18g2ayk";
const customHoursViewCss = "c1eu5bmz";
export const CustomHoursView = forwardRef((props, ref) => {
  const {
    compact,
    isExtraSmallPhone,
    v4Styling = false
  } = props;
  const displayLegend = false;
  const alwaysAbbreviate = true;
  const allowCopy = props.allowCopy || false;
  const isTabletUp = useDeviceType('isTabletUp');
  const isRedesignStyling = props.redesignStyling;
  return <DaysView ref={ref} {...props} displayLegend={displayLegend} alwaysAbbreviate={alwaysAbbreviate} allowCopy={allowCopy} v4Styling={v4Styling} className={classNames(customHoursViewCss, {
    [customHoursViewIsTabletUpCss]: isTabletUp,
    [customHoursViewIsRedesignStylingCss]: isRedesignStyling && !v4Styling,
    [customHoursViewIsV4StylingCss]: v4Styling,
    [customHoursViewCompactCss]: compact && !v4Styling,
    [customHoursViewIsExtraSmallPhoneCss]: isExtraSmallPhone
  }, props.className)} />;
});

require("./custom_hours.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./custom_hours.js");